import(/* webpackMode: "eager" */ "/codebuild/output/src1362980284/src/src/app/global-error.tsx");
